import { PAGE } from "#/constants";

export const commonMenus = [
  {
    id: 0,
    label: "Início",
    routerOrhref: PAGE.ROOT(),
    route: true,
  },
  {
    id: 1,
    label: "Vitrine de Parceiros",
    routerOrhref: PAGE.PARTNERS_SHOWCASE(),
    route: true,
  },
  {
    id: 2,
    label: "Recargas e Gift Card",
    routerOrhref: PAGE.RECHARGES(),
    route: true,
  },
  {
    id: 3,
    label: "Nossas Parcerias e Descontos",
    routerOrhref: PAGE.BENEFITS_PARTNER(),
    route: true,
  },
];

export function handlerNotRouters(router: string) {
  if (router === "") {
    return;
  }
  window.open(router, "_self");
}
